import { apiClient } from "./apiClient";

export type LiveHoursScope = "LEGAL_ENTITY" | "BRANCH";
export type LiveHoursRepeatMode = "DAILY" | "WEEKLY";
export type LiveHoursTimeMode = "SAME_ALL_DAYS" | "DIFFERENT_PER_DAY";
export type LiveHoursDay =
  | "MONDAY"
  | "TUESDAY"
  | "WEDNESDAY"
  | "THURSDAY"
  | "FRIDAY"
  | "SATURDAY"
  | "SUNDAY";

export interface LiveHoursTiming {
  startTime: string;
  endTime: string;
}

export interface LiveHoursScheduleItem {
  day: LiveHoursDay;
  enabled: boolean;
  /** All bookable windows for the day. Non-overlapping, ordered by start time. */
  timing?: LiveHoursTiming[] | null;
}

export interface LiveHoursPayload {
  scope: LiveHoursScope;
  legalEntityId: string;
  branchId: string | null;
  repeatMode: LiveHoursRepeatMode;
  timeMode: LiveHoursTimeMode;
  /** True when the service is live round the clock; the schedule below then covers every day in full. */
  alwaysOn?: boolean;
  /** IANA zone the window times are interpreted in, e.g. "Europe/London". */
  timezone: string;
  /** Windows shared by every enabled day in SAME_ALL_DAYS mode. */
  commonSchedule: LiveHoursTiming[] | null;
  schedule: LiveHoursScheduleItem[];
}

export const liveHoursService = {
  get: (params: { legalEntityId: string; branchId?: string | null }): Promise<LiveHoursPayload> =>
    apiClient
      .get<LiveHoursPayload>("/booking/live-hours", {
        params: {
          legalEntityId: params.legalEntityId,
          ...(params.branchId ? { branchId: params.branchId } : {}),
          skipGlobalContext: true,
        },
      })
      .then((response) => response.data),

  save: (payload: LiveHoursPayload): Promise<LiveHoursPayload> =>
    apiClient.post<LiveHoursPayload>("/booking/live-hours", payload).then((response) => response.data),
};
